export const marketplaceListingEditorTour = {
  tourKey: 'marketplace_listing_editor',
  conditions: {
    orgTypes: ['npo', 'business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      // No target - centered welcome popover
      title: 'tours.marketplace-listing-editor.welcome.title',
      content: 'tours.marketplace-listing-editor.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="marketplace-food-types"]',
      title: 'tours.marketplace-listing-editor.food-types.title',
      content: 'tours.marketplace-listing-editor.food-types.content',
      placement: 'top',
    },
    {
      target: '[data-tour="marketplace-pricing-tiles"]',
      title: 'tours.marketplace-listing-editor.pricing.title',
      content: 'tours.marketplace-listing-editor.pricing.content',
      placement: 'top',
    },
    {
      target: '[data-tour="marketplace-payout-summary"]',
      title: 'tours.marketplace-listing-editor.payout.title',
      content: 'tours.marketplace-listing-editor.payout.content',
      placement: 'left',
    },
    {
      target: '[data-tour="marketplace-fulfillment"]',
      title: 'tours.marketplace-listing-editor.fulfillment.title',
      content: 'tours.marketplace-listing-editor.fulfillment.content',
      placement: 'top',
    },
    {
      target: '[data-tour="marketplace-scheduling"]',
      title: 'tours.marketplace-listing-editor.scheduling.title',
      content: 'tours.marketplace-listing-editor.scheduling.content',
      placement: 'top',
    },
    {
      target: '[data-tour="marketplace-tax-exempt"]',
      title: 'tours.marketplace-listing-editor.tax-exempt.title',
      content: 'tours.marketplace-listing-editor.tax-exempt.content',
      placement: 'top',
    },
  ],
};
